/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { Description, DivRelative, SubTitle } from '../../components/layouts';
import { buildImageURL, clamp } from '../../helpers';
import './style.scss';
import { motion } from 'framer-motion';

const variants_title = {
  done: {
    opacity: 1,
    y: 0
  },
  doing: {
    opacity: 1,
    y: 0
  },
  will: {
    opacity: 0.2,
    y: 40
  }
};
const variants_title_first = {
  done: {
    opacity: 1,
    y: 0
  },
  doing: {
    opacity: 1,
    y: 0
  },
  will: {
    opacity: 0.2,
    y: 40
  }
};

const variants_title_sub = {
  visible: {
    opacity: 1,
    y: 0
  },
  hidden: {
    opacity: 0,
    y: 20
  }
};

function getTitleStep(current, target) {
  if (current >= target) {
    return 'done';
  }
  return 'will';
}

export function MobileContent({ step }) {
  const titleStep = useMemo(() => {
    return clamp(0, step, 3);
  }, [step]);
  return (
    <div className="section-content">
      <DivRelative>
        <SubTitle>
          <motion.span
            key={'超级夜景'}
            className="title-wrapper"
            animate={getTitleStep(titleStep, 1)}
            variants={variants_title_first}
            transition={{
              opacity: { duration: 0.5 },
              y: { duration: 0.5 }
            }}
          >
            超级夜景
            <br />
          </motion.span>
          <motion.span
            key={'超广角'}
            className="title-wrapper"
            animate={getTitleStep(titleStep, 1)}
            variants={variants_title}
            transition={{
              opacity: { duration: 0.5 },
              y: { duration: 0.5 }
            }}
          >
            超广角夜景
          </motion.span>
          <motion.span
            key={'超全景'}
            className="title-wrapper"
            animate={getTitleStep(titleStep, 1)}
            variants={variants_title}
            transition={{
              opacity: { duration: 0.5 },
              y: { duration: 0.5 }
            }}
          >
            ，全景夜景
          </motion.span>
        </SubTitle>
        <motion.div
          className="title-sub-wrapper"
          animate={titleStep >= 2 ? 'visible' : 'hidden'}
          variants={variants_title_sub}
          transition={{
            opacity: { delay: titleStep >= 2 ? 0.3 : 0, duration: 0.5 },
            y: { delay: titleStep >= 2 ? 0.3 : 0, duration: 0.5 }
          }}
        >
          <SubTitle>目光所及，打包全有</SubTitle>
        </motion.div>
      </DivRelative>
      <motion.div
        className="desc"
        animate={titleStep >= 2 ? 'visible' : 'hidden'}
        variants={variants_title_sub}
        transition={{
          opacity: { delay: titleStep >= 2 ? 0.5 : 0, duration: 0.5 },
          y: { delay: titleStep >= 2 ? 0.5 : 0, duration: 0.5 }
        }}
      >
        <Description>
          120° 的广角拍摄<sup>3</sup>，也可轻松创作夜景风光大片，一镜到手。广角还不够？全景夜景奉上。
        </Description>
      </motion.div>
    </div>
  );
}

const variants_image_mobile = {
  step1: {
    width: '70%',
    height: '70%'
  },
  step2: {
    width: '100%',
    height: '70%'
  },
  step3: {
    width: '100%',
    height: '100%'
  }
};

const IMAGE = buildImageURL('/s10-bg.jpg');

export function MobileImage({ step }) {
  const imageStep = useMemo(() => {
    return clamp(1, step, 3);
  }, [step]);
  return (
    <div className="superlens-image">
      <motion.div
        className="superlens-view-port"
        animate={`step${imageStep}`}
        variants={variants_image_mobile}
        transition={{
          width: { duration: 0.5 },
          height: { duration: 0.5 }
        }}
        style={{
          backgroundImage: `url(${IMAGE})`
        }}
      />
    </div>
  );
}
